<template>
  <svg
    width="242"
    height="235"
    viewBox="0 0 242 235"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_963_2081)">
      <circle cx="224" cy="21" r="80" fill="#40008A" />
    </g>
    <defs>
      <filter
        id="filter0_f_963_2081"
        x="0"
        y="-203"
        width="448"
        height="448"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="72"
          result="effect1_foregroundBlur_963_2081"
        />
      </filter>
    </defs>
  </svg>
</template>
